module.exports = __webpack_public_path__ + "static/1-244296e95a252ff3ac43f01a209fab2e.png";